module.exports = __webpack_public_path__ + "static/videos/litho_004.91736c5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_004.mp4
// module id = 473
// module chunks = 1